import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Prevents an already-logged-in user from landing back on /login, /signup, or
 * /forgot-password — e.g. clicking "Start Free Trial" while already authenticated
 * previously re-showed the signup form instead of just taking them to their dashboard.
 */
export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isLoggedIn()) {
    router.navigate(['/dashboard/overview']);
    return false;
  }

  return true;
};
